import { ROUTES } from 'config';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { locationSelectors } from 'redux/modules/Location';
import { checkDiscountsForMainPageAndExecute } from 'redux/modules/Discounts/discounts';
import { authSelectors } from 'redux/modules/Authorization';

export const useCheckDiscounts = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const currentLocation = useAppSelector(locationSelectors.getCurrentLocation);
  const currentUser = useAppSelector(authSelectors.getUser);

  useEffect(() => {
    currentLocation &&
      currentUser &&
      dispatch(
        checkDiscountsForMainPageAndExecute(
          currentLocation.id,
          currentUser.id,
          () => navigate(ROUTES.main, { replace: true }),
        ),
      );
  }, [currentLocation]);
};
